const ONE_HOUR_MS = 60 * 60 * 1000;

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

const isPwaDisabledByEnv = () =>
  String(process.env.REACT_APP_DISABLE_PWA || "").toLowerCase() === "true";

const shouldRegister = () =>
  process.env.NODE_ENV === "production" &&
  "serviceWorker" in navigator &&
  !isPwaDisabledByEnv();

const notifyInstalled = (registration, config) => {
  if (navigator.serviceWorker.controller) {
    if (config?.onUpdate) {
      config.onUpdate(registration);
    }
    return;
  }

  if (config?.onSuccess) {
    config.onSuccess(registration);
  }
};

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  });
}

export function register(config) {
  if (!shouldRegister()) return;

  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(swUrl);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            notifyInstalled(registration, config);
          }
        };
      };

      if (registration.waiting) {
        notifyInstalled(registration, config);
      }

      window.setInterval(() => {
        registration.update().catch(() => {
          // Keep app usable if update check fails due to temporary network issues.
        });
      }, ONE_HOUR_MS);

      if (isLocalhost) {
        // Localhost logs only; keeps production console clean.
        // eslint-disable-next-line no-console
        console.info("PWA service worker registered for localhost testing.");
      }
    } catch (error) {
      if (config?.onError) {
        config.onError(error);
        return;
      }
      // eslint-disable-next-line no-console
      console.error("PWA service worker registration failed.", error);
    }
  });
}
